import { gql } from '@apollo/client';

export const PAYMENT_PROVIDER_PAYMENT_TYPE_FRAGMENT = gql`
  fragment PaymentProviderPaymentTypeFields on PaymentProviderPaymentType {
    id
    name
    paymentProviderId
    type
    enabled
    supportedCurrencies
    gatewayFees
    gatewayFeeType
    paymentProvider {
      id
      description
    }
    platformFees
    platformFeeType
    createdAt
    updatedAt
  }
`;
